import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";
import Constants from "../../services/constants";
import { hideLoader, showLoader } from "./loaderSlice";
import { showToast } from "./toastSlice";

const initialState = {
  repos: [],
  repoBranches: [],
  connection: {},
};

export const getIntegrationReposAction = createAsyncThunk(
  "integrations/get-repos",
  async ({ data }, { dispatch }) => {
    try {
      const res = await api(
        "get",
        Constants.END_POINT.integration_repos + `?id=${data}`,
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setIntegrationRepos(res?.data));
      } else {
        dispatch(setIntegrationRepos([]));
        return Promise.reject(res.message);
      }
    } catch (error) {
      return Promise.reject(error.message || "An error occurred.");
    }
  }
);

export const getRepoBranchesAction = createAsyncThunk(
  "integrations/get-branches",
  async ({ repository }, { dispatch, getState }) => {
    try {
      dispatch(showLoader());
      const activeOrg = getState()?.org?.active;
      if (!activeOrg?.id) {
        throw new Error('No active organization found');
      }

      const res = await api(
        "get",
        Constants.END_POINT.integration_repo_branches +
          "?repo_full_name=" + repository +
          "&organization_id=" + activeOrg.id,
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setRepoBranches(res?.data));
      } else {
        return Promise.reject(res.message);
      }
    } catch (error) {
      return Promise.reject(error.message || "An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const integrationConnectionsAction = createAsyncThunk(
  "integrations/get-branches",
  async (data, { dispatch }) => {
    try {
      const res = await api(
        "get",
        Constants.END_POINT.integration_connections + `?id=${data}`,
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setConnections(res?.data));
      } else {
        return Promise.reject(res.message);
      }
    } catch (error) {
      return Promise.reject(error.message || "An error occurred.");
    }
  }
);

export const integrationAuthAction = createAsyncThunk(
  "integrations/auth",
  async ({ data, navigate }, { dispatch }) => {
    try {
      dispatch(showLoader());

      const res = await api("post", Constants.END_POINT.integration_auth, data);
      if (!res?.success) {
        return Promise.reject(res.message);
      }
    } catch (error) {
      return Promise.reject(error.message || "An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

const integrationSlice = createSlice({
  name: "integrations",
  initialState,
  reducers: {
    setIntegrationRepos: (state, action) => {
      state.repos = action.payload;
    },
    setRepoBranches: (state, action) => {
      state.repoBranches = action.payload;
    },
    setConnections: (state, action) => {
      state.connection = action.payload;
    },
  },
});

export const { setIntegrationRepos, setRepoBranches, setConnections } =
  integrationSlice.actions;

export default integrationSlice.reducer;
